import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { statusIconMapping } from '@iw/core/entities';

@Component({
  selector: 'iw-status-card',
  standalone: true,
  imports: [TranslateModule, IconModule],
  template: `
    <fu-icon size="16" [iconName]="icon()" />
    {{ statusText() | translate }}
  `,
  styleUrl: './status-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.icon-end]': 'position() === "right"',
  },
})
export class StatusCardComponent {
  status = input<string>();
  position = input<'left' | 'right'>('left');

  statusText = computed(() => this.status() ?? '');
  icon = computed(() => statusIconMapping.get(this.status() ?? '') ?? '');
}
